<div class="dialog-padding">
  <div class="dialog-container">
    <h2 mat-dialog-title class="title">Enter Payment</h2>
    <ng-container *ngIf="!(riderFareCollected$ | async) && fromStatus">
      <div id="riderFareCollectionDialog-text-mustCollectPaymentMessage" class="collect-fare-message">
        <small>In order to update ride status the driver must collect payment.</small>
        <br />
        <small>Please enter the payment details provided by the driver.</small>
      </div>
    </ng-container>
    <h3 id="riderFareCollectionDialog-text-amountDue" *ngIf="amountDue">Total Amount Due: {{ amountDue | currency }}</h3>
    <div mat-dialog-content>
      <ng-container *ngIf="amountDue">
        <form [formGroup]="fareCollectionForm">
          <ng-container *ngFor="let organizationPaymentMethod of supportedPaymentMethods">
            <ng-container [ngSwitch]="organizationPaymentMethod.paymentMethod.code">
              <div *ngSwitchCase="paymentMethodConstants.CASH" class="grid-container">
                <div class="grid-item">
                  <mat-label>{{ organizationPaymentMethod.name }}</mat-label>
                </div>
                <div class="grid-item"></div>
                <div class="grid-item data-field">
                  <ng-container *ngIf="!isCashCollectionEnabled; else CashInput">
                    <button
                      id="riderFareCollectionDialog-button-cashAmount"
                      mat-raised-button
                      type="button"
                      class="add-method-button"
                      color="primary"
                      (click)="addAnotherClick(organizationPaymentMethod)"
                      uzDebounceClick
                      [disabled]="areButtonsDisabled()"
                    >
                      {{ getAddButtonText(organizationPaymentMethod) }}
                    </button>
                  </ng-container>
                  <ng-template #CashInput>
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        uzCurrencyInput
                        ciCurrencyCode="USD"
                        id="riderFareCollectionDialog-input-cashAmount"
                        type="text"
                        [formControlName]="getFormControlName(organizationPaymentMethod)"
                      />
                    </mat-form-field>
                  </ng-template>
                </div>
                <div class="grid-item">
                  <button
                    id="riderFareCollectionDialog-button-deleteCash"
                    mat-icon-button
                    color="primary"
                    (click)="deleteFareClicked(organizationPaymentMethod, 0)"
                    *ngIf="isCashCollectionEnabled"
                    [disabled]="areButtonsDisabled()"
                  >
                    <mat-icon class="remove-button">do_not_disturb_on</mat-icon>
                  </button>
                </div>
              </div>
              <ng-container
                *ngSwitchCase="paymentMethodConstants.CONFIRMATION"
                [formArrayName]="getFormControlName(organizationPaymentMethod)"
              >
                <ng-container
                  *ngIf="fareCollectionForm.get(getFormControlName(organizationPaymentMethod))['controls'].length > 0; else ConfStartButton"
                >
                  <ng-container
                    *ngFor="
                      let form of fareCollectionForm.get(getFormControlName(organizationPaymentMethod))['controls'];
                      let i = index;
                      let first = first
                    "
                  >
                    <div
                      class="grid-container confirmation-container"
                      [formGroupName]="i"
                      [ngClass]="{ 'add-new': shouldShowAddAnotherButton(organizationPaymentMethod, i) }"
                    >
                      <div class="grid-item">
                        <mat-label *ngIf="first">{{ organizationPaymentMethod.name }}</mat-label>
                      </div>
                      <div class="grid-item"></div>
                      <div class="grid-item data-field">
                        <div class="form-input-container">
                          <mat-checkbox
                            id="riderFareCollectionDialog-checkBox-{{
                              getFormControlName(organizationPaymentMethod) | camelCase
                            }}PaymentConirmed-{{ i }}"
                            formControlName="confirmed"
                            color="primary"
                          >
                            {{ organizationPaymentMethod.name }} Confirmed
                          </mat-checkbox>

                          <div class="add-another-button-container" *ngIf="shouldShowAddAnotherButton(organizationPaymentMethod, i)">
                            <button mat-button class="add-another-button" (click)="addAnotherClick(organizationPaymentMethod)">
                              <mat-icon>add_circle_outline</mat-icon> Add Another
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="grid-item">
                        <button
                          id="riderFareCollectionDialog-button-delete-{{ organizationPaymentMethod.name | camelCase }}-{{ i }}"
                          mat-icon-button
                          color="primary"
                          (click)="deleteFareClicked(organizationPaymentMethod, 0)"
                          [disabled]="areButtonsDisabled()"
                        >
                          <mat-icon class="remove-button">do_not_disturb_on</mat-icon>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #ConfStartButton>
                  <div class="grid-container">
                    <div class="grid-item">
                      <mat-label>{{ organizationPaymentMethod.name }}</mat-label>
                    </div>
                    <div class="grid-item"></div>
                    <div class="grid-item data-field">
                      <button
                        id="riderFareCollectionDialog-button-confirmation-{{ organizationPaymentMethod.name | camelCase }}"
                        mat-raised-button
                        type="button"
                        class="add-method-button"
                        color="primary"
                        (click)="addAnotherClick(organizationPaymentMethod)"
                        uzDebounceClick
                        [disabled]="areButtonsDisabled()"
                      >
                        {{ getAddButtonText(organizationPaymentMethod) }}
                      </button>
                    </div>
                    <div class="grid-item"></div>
                  </div>
                </ng-template>
              </ng-container>
              <ng-container *ngSwitchDefault [formArrayName]="getFormControlName(organizationPaymentMethod)">
                <ng-container
                  *ngIf="
                    fareCollectionForm.get(getFormControlName(organizationPaymentMethod))['controls'].length > 0;
                    else DefaultStartButton
                  "
                >
                  <ng-container
                    *ngFor="
                      let form of fareCollectionForm.get(getFormControlName(organizationPaymentMethod))['controls'];
                      let i = index;
                      let first = first
                    "
                  >
                    <div
                      class="grid-container"
                      [formGroupName]="i"
                      [ngClass]="{ 'add-new': shouldShowAddAnotherButton(organizationPaymentMethod, i) }"
                    >
                      <div class="grid-item">
                        <mat-label *ngIf="first">{{ organizationPaymentMethod.name }}</mat-label>
                      </div>
                      <div class="grid-item data-field">
                        <mat-form-field appearance="outline" *ngIf="organizationPaymentMethod.ticketNumberRequired">
                          <input
                            id="rideFareCollectionDialog-input-{{ getFormControlName(organizationPaymentMethod) | camelCase }}Number-{{
                              i
                            }}"
                            matInput
                            [placeholder]="organizationPaymentMethod.name + ' #'"
                            type="text"
                            formControlName="paymentNumber"
                          />
                          <mat-error>
                            <div
                              id="riderFareCollection-text-invalidVoucherNumber"
                              *ngIf="invalidVoucherNumber(organizationPaymentMethod, i)"
                            >
                              Invalid Voucher Number
                            </div>
                            <div
                              id="riderFareCollection-text-requiredVoucherNumber"
                              *ngIf="requiredVoucherNumber(organizationPaymentMethod, i)"
                            >
                              Required
                            </div>
                            <div
                              id="riderFareCollection-text-noSpecialCharacters"
                              *ngIf="noSpecialCharacters(organizationPaymentMethod, i)"
                            >
                              No Special Characters
                            </div>
                            <div id="riderFareCollection-text-maxVoucherUsage" *ngIf="maxVoucherNumberUsage(organizationPaymentMethod, i)">
                              Voucher Number Has Exceeded Max Usage.
                            </div>
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="grid-item data-field">
                        <mat-form-field appearance="outline">
                          <input
                            id="rideFareCollectionDialog-input-{{ getFormControlName(organizationPaymentMethod) | camelCase }}Value-{{ i }}"
                            matInput
                            uzCurrencyInput
                            ciCurrencyCode="USD"
                            type="text"
                            formControlName="paymentValue"
                          />
                          <mat-error>
                            <div *ngIf="invalidVoucherValue(organizationPaymentMethod, i)">Invalid Amount</div>
                            <div *ngIf="requiredVoucherValue(organizationPaymentMethod, i)">Required</div>
                          </mat-error>

                          <div class="add-another-button-container" *ngIf="shouldShowAddAnotherButton(organizationPaymentMethod, i)">
                            <button
                              id="riderFareCollectionDialog-button-addAnother-{{ organizationPaymentMethod.name | camelCase }}"
                              mat-button
                              class="add-another-button"
                              (click)="addAnotherClick(organizationPaymentMethod)"
                            >
                              <mat-icon>add_circle_outline</mat-icon> Add Another
                            </button>
                          </div>
                        </mat-form-field>
                      </div>
                      <div class="grid-item">
                        <button
                          id="riderFareCollectionDialog-button-deleteDefault-{{ organizationPaymentMethod.name | camelCase }}-{{ i }}"
                          mat-icon-button
                          color="primary"
                          (click)="deleteFareClicked(organizationPaymentMethod, i)"
                          [disabled]="areButtonsDisabled()"
                        >
                          <mat-icon class="remove-button">do_not_disturb_on</mat-icon>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #DefaultStartButton>
                  <div class="grid-container">
                    <div class="grid-item">
                      <mat-label>{{ organizationPaymentMethod.name }}</mat-label>
                    </div>
                    <div class="grid-item"></div>
                    <div class="grid-item data-field">
                      <button
                        id="riderFareCollectionDialog-button-default-{{ organizationPaymentMethod.name | camelCase }}"
                        mat-raised-button
                        type="button"
                        class="add-method-button"
                        color="primary"
                        (click)="addAnotherClick(organizationPaymentMethod)"
                        uzDebounceClick
                        [disabled]="areButtonsDisabled()"
                      >
                        {{ getAddButtonText(organizationPaymentMethod) }}
                      </button>
                    </div>
                    <div class="grid-item"></div>
                  </div>
                </ng-template>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="fromStatus">
            <div class="checkbox-container">
              <mat-checkbox
                id="riderFareCollectionDialog-checkBox-cannotPayFare"
                formControlName="cannotPayFare"
                [checked]="fareCollectionForm.get('cannotPayFare').value"
                color="primary"
                type="checkbox"
                class="checkbox"
              >
              </mat-checkbox>
              <mat-label>Rider Cannot Pay Fare</mat-label>
            </div>
          </ng-container>
        </form>
      </ng-container>
    </div>
    <div>
      <hr />
      <span>
        <div class="total-collected">Total Amount Collected:</div>
        <div
          id="riderFareCollectionDialog-text-totalAmountCollected"
          class="total-collected"
          [ngClass]="{ success: amountDue === runningTotal }"
        >
          {{ runningTotal | currency }}
        </div>
        <div class="total-collected success check-mark-icon" *ngIf="amountDue === runningTotal">
          <mat-icon id="riderFareCollection-icon-totalFareIsCollected">check</mat-icon>
        </div>
      </span>
      <div id="riderFareCollection-text-totalFareExceeded" [hidden]="!overcharged" class="overchargeMessage">
        The total collected must not exceed the total amount due.
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <span>
        <button id="riderFareCollection-button-cancel" mat-stroked-button type="button" color="primary" (click)="cancel()">Cancel</button>
        <button
          id="riderFareCollection-button-submit"
          mat-raised-button
          type="button"
          color="primary"
          (click)="submitForm()"
          [disabled]="isSubmitDisabled() || (isSubmittingRiderFares$ | async)"
          uzDebounceClick
        >
          Submit
        </button>
      </span>
    </div>
  </div>
</div>
